import { IServicePersons } from "../interfaces";

export function getMakuderovFluffies() {
	const output: Array<IServicePersons> = [];

	// nase rodina
	output.push({
		group: "makuderovi-plysaci",
		items: [
			{ key: "PLY_KVA", fullName: "Kvákalka", sex: "F", birthdate: "1991-07", isFluffy: true },
			{ key: "PLY_KOC", fullName: "Kočičon", sex: "M", birthdate: "1993", isFluffy: true },
			{ key: "PLY_KRI", fullName: "Křivonožka", sex: "M", birthdate: "2019-01-26", isFluffy: true },
			{ key: "PLY_MYV", fullName: "Mýval", sex: "M", birthdate: "2020-02-16", isFluffy: true },
			{ key: "PLY_MYV2", fullName: "Mýval placatý", sex: "M", birthdate: "2020-10-10", isFluffy: true },
			{ key: "PLY_MYV3", fullName: "Mýval háčkovaný", sex: "M", birthdate: "2020-12-24", isFluffy: true },
			{ key: "PLY_KOC2", fullName: "Kočička", sex: "F", birthdate: "2020-12-24", isFluffy: true },
			{ key: "PLY_MYV4", fullName: "Mýval Marťa", sex: "M", birthdate: "2021-03-28", isFluffy: true },
			{ key: "PLY_SOV", fullName: "Sova", sex: "F", birthdate: "2021-05-08", isFluffy: true },
			{ key: "PLY_RYB", fullName: "Ryba", sex: "F", birthdate: "2021-09-23", isFluffy: true },
			{ key: "PLY_GUL", fullName: "Gula", sex: "F", birthdate: "2021-11-14", isFluffy: true },
			{ key: "PLY_OVC", fullName: "Ovce", sex: "F", birthdate: "2022-02-04", isFluffy: true },
			{ key: "PLY_HRA", fullName: "Hrabák", sex: "M", birthdate: "2022-05-08", isFluffy: true },
			{ key: "PLY_RYS", fullName: "Rysátko", sex: "M", birthdate: "2022-08-09", isFluffy: true },
			{ key: "PLY_ZIR", fullName: "Žirafa žlutá", sex: "F", birthdate: "2022-10-22", isFluffy: true },
			{ key: "PLY_SOV2", fullName: "Sova Tomi", sex: "F", birthdate: "2022-12-12", isFluffy: true },
			{ key: "PLY_VYD", fullName: "Vydra", sex: "F", birthdate: "2022-12-11", isFluffy: true },
			{ key: "PLY_YOD", fullName: "Yoda", sex: "M", birthdate: "2023-05-08", isFluffy: true },
			{ key: "PLY_ZEL", fullName: "Želva", sex: "F", birthdate: "2023-09-07", isFluffy: true },
			{ key: "PLY_RYB2", fullName: "Ryba 2", sex: "F", birthdate: "2023-10-31", isFluffy: true },
			{ key: "PLY_ZIR2", fullName: "Žirafa modrá", sex: "F", birthdate: "2023-10-21", isFluffy: true },
			{ key: "PLY_MYV5", fullName: "Mýval malý", sex: "M", birthdate: "2023-11-25", isFluffy: true },
			{ key: "PLY_PIP", fullName: "Pipíp", sex: "M", birthdate: "2023-11-25", isFluffy: true },
			{ key: "PLY_CHO", fullName: "Chobotnička", sex: "F", birthdate: "2023-11-25", isFluffy: true },
			{ key: "PLY_HUS", fullName: "Husa", sex: "F", birthdate: "2024-01-28", isFluffy: true },
			{ key: "PLY_JEL", fullName: "Jelen", sex: "M", birthdate: "2024-08-09", isFluffy: true },
			{ key: "PLY_MYV6", fullName: "Mýval vánoční", sex: "M", birthdate: "2024-11-21", isFluffy: true },
			{ key: "PLY_PAN", fullName: "Panenka", sex: "F", birthdate: "2024-11-30", isFluffy: true },
			{ key: "PLY_SOV3", fullName: "Sova malá", sex: "F", birthdate: "2024-12", isFluffy: true },
			{ key: "PLY_KUN", fullName: "Kůň", sex: "M", birthdate: "2025-04-19", isFluffy: true },
			{ key: "PLY_VCE", fullName: "Včela Minecraft", sex: "F", birthdate: "2025-07-19", isFluffy: true },
			{ key: "PLY_CRE", fullName: "Creeper Minecraft", sex: "M", birthdate: "2025-07-21", isFluffy: true },
			{ key: "PLY_LIS", fullName: "Liška Minecraft", sex: "F", birthdate: "2025-07-25", isFluffy: true },
			{ key: "PLY_CHA", fullName: "Chase", sex: "M", birthdate: "2025-12-24", isFluffy: true },
			{ key: "PLY_KRT", fullName: "Krteček", sex: "M", birthdate: "2025-12-24", isFluffy: true },
			{ key: "PLY_ROC", fullName: "Rocky", sex: "M", birthdate: "2026-03-07", isFluffy: true },
			{ key: "PLY_VCE2", fullName: "Včela Ikea", sex: "F", birthdate: "2026-07-10", isFluffy: true },
			{ key: "PLY_MYV7", fullName: "Mýval Marťa huňatý", sex: "M", birthdate: "2026-10-02", isFluffy: true },
			{ key: "PLY_SOV4", fullName: "Sova Tomi huňatá", sex: "F", birthdate: "2026-10-02", isFluffy: true },
		],
	});

	return output;
}
